<template>
  <ul :class="['cm-documentation__content-list', {'no-marker': data.class === 'no-marker'}]">
    <li v-for="(list, index) in data.content" :key="index">
      <div v-for="(item, index) in list" :key="index">
        <PageContent :type="item.type" :data="item" />
      </div>
    </li>
  </ul>
</template>

<script>
import PageContent from "@/components/documentation/PageContent.vue";

export default {
  components: {
    PageContent,
  },

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.no-marker {
  list-style-type: none;
}
</style>